import { useEffect } from "react";
import styled, { keyframes } from "styled-components";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import BackgroundImage from "../../assets/images/hide.jpg";
import lendingPartners from "./lendingPartners";
const zoomInOut = keyframes`
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.08);
    }
    100% {
        transform: scale(1);
    }
`;
const LogoWrapper = styled.div`
    width: 180px;
    height: 80px;
    margin: 0 auto 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        max-width: 100%;
        max-height: 70px;
        object-fit: contain;
    }
`;
const Card = styled.div`
    background: #fff;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    height: 100%;
`;

const Heading = styled.h2`
    color: #0d6efd;
    font-size: 1.6rem;
    font-weight: 700;
    margin-bottom: 25px;
`;

const HeroSection = styled.header`
    position: relative;
    height: 35vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, .45);
        z-index: 2;
    }

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: url(${BackgroundImage}) center/cover no-repeat;
        animation: ${zoomInOut} 12s infinite;
        z-index: 1;
    }

    .container {
        position: relative;
        z-index: 3;
    }
`;

const HeroTitle = styled.h1`
    color: #fff;
    font-size: 2.6rem;
    font-weight: 700;
`;

const HeroSubtitle = styled.p`
    color: rgba(255,255,255,.9);
    font-size: 1.1rem;
    margin-top: 10px;
`;

const Section = styled.section`
    padding: 70px 0;
`;

export default function LendingPartners() {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    const navigateMenu = () => {};

    return (
        <>
            <Header navigateMenu={navigateMenu} />

            <HeroSection>
                <div className="container text-center">
                    <HeroTitle>
                        Our Lending Partners
                    </HeroTitle>

                    <HeroSubtitle>
                        We partner with trusted RBI Registered Lending Institutions
                        to offer secure and transparent financial solutions.
                    </HeroSubtitle>
                </div>
            </HeroSection>

            <Section>
                <div className="container">
                    {lendingPartners.map((partner) => (
                        <Card key={partner.id}>
                            <LogoWrapper>
                                <img
                                    src={partner.logo}
                                    alt={partner.brandName}
                                />
                            </LogoWrapper>
                            <Heading>{partner.brandName}</Heading>

                            <p>
                                <strong>Legal Name:</strong> {partner.legalName}
                            </p>

                            <p>
                                <strong>Website:</strong>{" "}
                                <a
                                    href={partner.website}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {partner.website}
                                </a>
                            </p>

                            <p>
                                <strong>KFS:</strong>{" "}
                                <a
                                    href={partner.kfs}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    View
                                </a>
                            </p>

                            <hr />

                            <Heading style={{ fontSize: "1.3rem" }}>
                                Grievance Officer
                            </Heading>

                            <p><strong>Name:</strong> {partner.grievanceOfficer.name}</p>
                            <p><strong>Designation:</strong> {partner.grievanceOfficer.designation}</p>
                            <p><strong>Working Hours:</strong> {partner.grievanceOfficer.workingHours}</p>
                            <p><strong>Contact:</strong> {partner.grievanceOfficer.contact}</p>
                            <p><strong>Email:</strong> {partner.grievanceOfficer.email}</p>
                            <p><strong>Address:</strong> {partner.grievanceOfficer.address}</p>

                            <hr />

                            <Heading style={{ fontSize: "1.3rem" }}>
                                Principal Nodal Officer
                            </Heading>

                            <p><strong>Name:</strong> {partner.nodalOfficer.name}</p>
                            <p><strong>Designation:</strong> {partner.nodalOfficer.designation}</p>
                            <p><strong>Company:</strong> {partner.nodalOfficer.companyName}</p>
                            <p><strong>Contact:</strong> {partner.nodalOfficer.contact}</p>
                            <p><strong>Email:</strong> {partner.nodalOfficer.email}</p>
                            <p><strong>Address:</strong> {partner.nodalOfficer.address}</p>
                        </Card>
                    ))}
                </div>
            </Section>

            <Footer className="footer_section custom_footer_style" />
        </>
    );
}